import { CustomError } from '@tencent/memoire-error-utils';
export var UnexpectedOutsideMigrationActionError = CustomError.withMessageCreator('UnexpectedOutsideMigrationActionError', function (op) {
    return op + " outside ensure(callback) is not allowed, " + 'please wrap your migration actions inside a ensure callback';
});
//# sourceMappingURL=errors.js.map